module.exports = __webpack_public_path__ + "img/error.06723520.svg";